var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainForm',{attrs:{"name":_vm.FORM_NAMES.merchant,"show-step":_vm.isOnStep,"logic-callbacks":_vm.getLogicCallback,"ui-form":_vm.uiForm,"end-page-data":_vm.endPageData,"ui-modal-and-end-page":_vm.uiModalAndEndPage,"ui-title":"Main form title"}},[_c('StepModel',{attrs:{"ui":_vm.uiBaseStep,"name":_vm.STEP_NAMES.contact,"ui-title":"Contact Information","ui-subtitle":"","ui-error-message":"Please review the fields marked in red","ui-button-text":"Submit"}},[_c('FieldsetFullName'),_c('FieldsetModel',{attrs:{"ui":_vm.uiBaseFieldset,"name":"companyName","ui-title":"Company Name"}},[_c('UiWrapper',{attrs:{"name":_vm.FIELD_NAMES.companyName,"label":"Type the name of your company"}},[_c('InputText')],1)],1),_c('FieldsetEmail',{attrs:{"subtitle":""}}),_c('FieldsetMobilePhone',{attrs:{"subtitle":""}}),_c('FieldsetModel',{attrs:{"ui":_vm.uiBaseFieldset,"name":"emirates","ui-title":"Emirate"}},[_c('UiWrapper',{attrs:{"name":_vm.FIELD_NAMES.emirates}},[_c('Dropdown',{attrs:{"placeholder":"Emirate","options":[
              {
                value: 'Abu Dhabi',
                label: 'Abu Dhabi'
              },
              {
                value: 'Dubai',
                label: 'Dubai'
              },
              {
                value: 'Sharjah',
                label: 'Sharjah'
              },
              {
                value: 'Ajman',
                label: 'Ajman'
              },
              {
                value: 'Umm Al Quwain',
                label: 'Umm Al Quwain'
              },
              {
                value: 'Ras Al Khaimah',
                label: 'Ras Al Khaimah'
              },
              {
                value: 'Fujairah',
                label: 'Fujairah'
              }
            ]}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }